import { ControllerProps } from "csi/middleware/common";
import { SaveDialog } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { BaseCompositionStore, BaseCompositionStoreContext } from "./BaseCompositionStore";
import MainBaseCompositionData from "./MainBaseCompositionData";

interface BaseCompositionSaveDialogWrapperProps extends ControllerProps {}

const BaseCompositionSaveDialogWrapper: FunctionComponent<BaseCompositionSaveDialogWrapperProps> = observer(
	function BaseCompositionSaveDialogWrapper(props) {
		const {
			store,
			...otherProps
		} = props;	
		const baseCompositionStore = store as BaseCompositionStore;
		const { mainDialogOnCancel, mainDialogOnSave } = baseCompositionStore;
		return (
			<>
				{baseCompositionStore && (
					<BaseCompositionStoreContext.Provider value={baseCompositionStore}>
						<SaveDialog
							{...otherProps}
							contentSpacing={0}
							dataCsiAutomation="CompositionDialog"
							disableEnforceFocus
							fullHeight
							onCancel={mainDialogOnCancel}
							onSave={mainDialogOnSave}
							open
							scrollContent="belowMessage"
							sx={{ overflow: "hidden" }}
							width="1200px"
						>
							{{
								main: <MainBaseCompositionData />,
							}}
						</SaveDialog>
					</BaseCompositionStoreContext.Provider>
				)}
			</>
		);
	},
);

export default BaseCompositionSaveDialogWrapper;
